import { Theme, createStyles, makeStyles } from '../../../../../UI/MaterialUI'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: '0px',
      width: '100%'
    },
    label: {
      minWidth: '86px'
    },
    rightSeparation: {
      marginRight: '8px'
    },
    listItem: {
      display: 'flex',
      minHeight: '58px',
      justifyContent: 'space-between !important',
      width: 'inherit'
    },
    italic:{
      fontStyle: 'italic'
    },
    item: {
      color: 'var(--head-text-color)',
      fontFamily: 'LatoNormal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px'
    },
    itemType: {
      color: 'var(--head-text-color)',
      fontFamily: 'LatoNormal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      margin: '5px 0px 0px 0px'
    },
    itemEnd: {
      color: 'var(--head-text-color)',
      fontFamily: 'LatoNormal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      alignSelf: 'flex-end',
      marginRight: '12px'
    },
    row: {
      display: 'flex',
      flexDirection: 'row'
    },
    column: {
      display: 'flex',
      flexDirection: 'column'
    },
    price: {
      fontFamily: 'Lato',
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '58px',
      color: 'var(--head-text-color)'
    },
    icon: {
      color: 'var(--head-text-color)',
      margin: '18px 8px'
    },
    expand: {
      color: 'var(--white-color)'
    },
    expandBox: {
      display: 'flex',
      width: '26px',
      height: '26px',
      borderRadius: '4px',
      backgroundColor: 'var(--bosscat-blue-600)',
      justifyContent: 'center',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: 'var(--button-focus-color)',
        borderColor: 'var(--button-focus-color)',
        boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 1px rgba(26, 42, 85, 0.31)'
      }
    },
    itemPercent: {
      fontFamily: 'LatoNormal',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      color: 'var(--white-color)'
    },
    descr: {
      fontFamily: 'LatoNormal',
      margin: '6px 0px'
    },
    container: {
      width: '100%',
      padding: '0px 20px 15px 20px',
      backgroundColor: 'var(--background-color-secondary)'
    },
    image: {
      margin: '6px 0px 4px 0px'
    },
    buttonRemove: {
      width: '220px',
      height: '45px',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--delete-button-color)',
      borderRadius: 8,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '40px'
      },
      margin: '5px',
      '&:hover': {
        backgroundColor: 'var(--expired-color)'
      }
    },
    buttonAdd: {
      width: '220px',
      height: '45px',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-green-600)',
      borderRadius: 8,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '40px'
      },
      margin: '5px',
      '&:hover': {
        backgroundColor: 'var(--bosscat-green-700)'
      }
    },
    buttonClose: {
      width: '220px',
      height: '45px',
      textTransform: 'none',
      color: 'var(--bosscat-blue-600)',
      backgroundColor: 'white',
      borderRadius: 8,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '40px'
      },
      margin: '5px',
      '&:hover': {
        backgroundColor: '#1A2A55'
      }
    },
    buttonContent: {
      justifyContent: 'flex-end'
    },
    containerBox: {
      display: 'flex',
      width: 'fit-content',
      flexDirection: 'column'
    },
    alert: {
      width: '100%',
      height: '500px',
      backgroundColor: 'var(--white-color)',
      border: '2px solid var(--border-color)',
      borderRadius: '16px 16px 0px 0px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      position: 'sticky',
      bottom: 0,
      zIndex: 11
    }
  })
)
